import React, { useEffect, useRef, useState } from "react";
import KochaHeader from "../KochaHeader";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";
import { Button, Collapse, Dropdown, Modal, Popconfirm, Skeleton } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import numberToWords from "../../../Components/NumberToWords/NumberToWords";
import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  MdOutlineCalculate,
  MdOutlineDeleteOutline,
  MdOutlineRemoveCircleOutline,
} from "react-icons/md";
import { PiHamburger } from "react-icons/pi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LiaTrainSolid } from "react-icons/lia";
import { GoPlusCircle } from "react-icons/go";
import { CiEdit } from "react-icons/ci";
import { VscListFlat } from "react-icons/vsc";
import { CgTrashEmpty } from "react-icons/cg";

export default function VagonView() {
  let [loadVagon, setLoadVagon] = useState(false);
  let [loading, setLoading] = useState(false);
  let [dataDetail, setDataDetail] = useState({});
  const messageApi = useMessage();
  let { id } = useParams();
  let navigate = useNavigate();
  let [isModalOpen, setIsModalOpen] = React.useState(false);
  let [oneChiqimEdit, setOneChiqimEdit] = React.useState(false);
  let [oneChiqim, setOneChiqim] = React.useState(null);
  let [isFinished, setIsFinished] = React.useState(false);
  let [data, setData] = useState({
    chiqim: [],
  });

  const formikRef = useRef(null);

  const showModal = async () => {
    try {
      setLoadVagon(true);

      let info = await axiosInstance.get("/api/vagon/" + id);

      console.log(info);

      if (info.data.success) {
        // setOpenStatByModal(true);
        setDataDetail({ ...dataDetail, ...info.data.data });
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoadVagon(false);
    }
  };

  const getChiqim = async () => {
    try {
      setLoadVagon(true);
      console.log(id);
      let info = await axiosInstance.get("/api/vagon_ichi/" + id);
      console.log(info.data.data);
      if (info.data.success) {
        // setOpenStatByModal(true);
        setData({
          chiqim: [...info.data.data],
          total: info.data.data.reduce((acc, curr) => {
            return acc + curr?.qop;
          }, 0),
        });
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoadVagon(false);
    }
  };

  const setChiqim = async (values, resetForm) => {
    try {
      setLoading(true);

      let info = await axiosInstance.post("/api/vagon_ichi", {
        vagon_id: id,
        ...values,
        tonna: (data.qop * 50) / 1000,
      });
      console.log(info);
      if (info.data.success) {
        setData({
          chiqim: [info.data.data, ...data.chiqim],
        });
        resetForm();
        setIsModalOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const putChiqim = async (values) => {
    try {
      setLoading(true);

      let info = await axiosInstance.put("/api/vagon_ichi/" + oneChiqim?.id, {
        vagon_id: id,
        ...values,
        tonna: (data.qop * 50) / 1000,
      });
      console.log(info);
      if (info.data.success) {
        getChiqim();

        setOneChiqimEdit(false);
        setOneChiqim(null);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const delChiqim = async (id) => {
    try {
      setLoading(true);

      let info = await axiosInstance.delete("/api/vagon_ichi/" + id);
      console.log(info);
      if (info.data.success) {
        setData({
          chiqim: [
            ...data.chiqim.filter((el) => {
              if (el.id !== id) {
                return el;
              }
            }),
          ],
        });
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const deleteVagon = async () => {
    try {
      setLoading(true);

      let info = await axiosInstance.delete("/api/vagon/" + id);
      console.log(info);
      if (info.data.success) {
        navigate("/kocha/vagonlar");
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const finishVagon = async (values) => {
    try {
      setLoading(true);

      let info = await axiosInstance.post("/api/vagon/confirm", {
        id: id,
        confirm: 1,
        confirm_comment: values.comment,
      });
      console.log(info);
      if (info.data.success) {
        navigate("/kocha/vagonlar");
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const cancelFinishVagon = async () => {
    try {
      setLoading(true);

      let info = await axiosInstance.post("/api/vagon/confirm", {
        id: id,
        confirm: 0,
        confirm_comment: "",
      });
      console.log(info);
      if (info.data.success) {
        navigate("/kocha/vagonlar");
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    showModal();
    getChiqim();
  }, []);

  if (loadVagon) {
    return (
      <div className="max-w-[900px] w-[100%] m-auto">
        <KochaHeader title={"Vagon "} />
        <br></br>
        <Skeleton active />
        <br></br>
        <Skeleton active />
      </div>
    );
  }

  const items = [
    {
      key: "2",
      disabled: dataDetail?.confirm,
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to={"/kocha/vagonlar/edit/" + id}
        >
          <CiEdit className="font-[30px]" /> O'zgartirish
        </Link>
      ),
    },
    {
      key: "3",
      disabled: dataDetail?.confirm,
      label: (
        <div
          disabled={true}
          onClick={() => {
            if (!dataDetail?.confirm) {
              setIsModalOpen(true);
            }
          }}
          className={" block w-[100%] flex items-center justify-start gap-1"}
          rel="noopener noreferrer"
        >
          <GoPlusCircle className="font-[30px]" /> Chiqim
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <>
          {dataDetail?.confirm ? (
            <Popconfirm
              title="Bekor qilish!"
              description={"Yakunlanganini bekor qilmoqchimisz?"}
              onConfirm={cancelFinishVagon}
              okText="Yes"
              cancelText="No"
            >
              <div
                // onClick={() => {
                //   // setIsFinished(true);
                // }}
                className=" block w-[100%] flex items-center justify-start gap-1"
                rel="noopener noreferrer"
                to="/"
              >
                <MdOutlineCalculate className="font-[30px]" />{" "}
                {dataDetail?.confirm_by}
              </div>
            </Popconfirm>
          ) : (
            <div
              onClick={() => {
                setIsFinished(true);
              }}
              className=" block w-[100%] flex items-center justify-start gap-1"
              rel="noopener noreferrer"
              to="/"
            >
              <MdOutlineCalculate className="font-[30px]" /> Yakunlash
            </div>
          )}
        </>
      ),
    },
  ];

  let collapsedItems = [
    {
      key: "1",
      label: "Vagon malumoti",
      children: (
        <div>
          <div className="w-[100%]">
            <label className="text-[14px] samibold text-slate-900">Berdi</label>
            <p className="px-[15px] text-[12px] text-[#364153] m-0 px-0">
              {dataDetail?.given_by}
            </p>
          </div>
          <div className="px-[15px] border-t-[1px] py-[4px] border-[#bfbfbf] w-[100%]">
            <label className="text-[14px] samibold text-slate-900">Yozdi</label>
            <p className=" px-[15px] text-[12px] text-[#364153] m-0 py-1">
              {dataDetail?.written_by}
            </p>
          </div>
          <div className="px-[15px] border-t-[1px] py-[4px] border-[#bfbfbf] w-[100%]">
            <label className="text-[14px] samibold text-slate-900">
              Yozildi
            </label>
            <p className="px-[15px] text-[12px] text-[#364153] m-0 p-0">
              {moment(dataDetail?.created_at).format("MMMM Do, YYYY h:mm A")}
            </p>
          </div>
          <div className="px-[15px] border-t-[1px] py-[4px] border-[#bfbfbf] w-[100%]">
            <label className="text-[14px] samibold text-slate-900">Izox</label>
            <p className="px-[15px] text-[12px] text-[#364153] m-0 p-0">
              {dataDetail?.comment}
            </p>
          </div>{" "}
        </div>
      ),
    },
    {
      key: "2",
      label: "Vagon yakunlash malumoti",
      children: (
        <div>
          <div className="w-[100%]">
            <label className="text-[14px] samibold text-slate-900">
              Yakunladi
            </label>
            <p className="px-[15px] text-[12px] text-[#364153] m-0 px-0">
              {dataDetail?.confirm_by}
            </p>
          </div>
          <div className="px-[15px] border-t-[1px] py-[4px] border-[#bfbfbf] w-[100%]">
            <label className="text-[14px] samibold text-slate-900">Izox</label>
            <p className=" px-[15px] text-[12px] text-[#364153] m-0 py-1">
              {dataDetail?.confirm_comment}
            </p>
          </div>
        </div>
      ),
    },
  ];
  return (
    <div className="max-w-[900px] w-[100%] m-auto">
      <KochaHeader title={"Vagon "} />
      <div
        className="flex flex-col gap-6 "
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          class="max-w-[900px] w-[100%] font-sans"
          style={{
            paddingBottom: "30px",
          }}
        >
          <h2 className="px-[30px] mt-1 m-0 text-md font-semibold text-s  text-black sm:text-black-900 md:text-2xl dark:sm:text-[#000] text-[#6b7280]">
            {/* {moment(dataDetail?.date).format("DD.MM.YYYY")}  */}
            Vagon № {dataDetail?.vagon}{" "}
          </h2>
          <div className="px-[30px]">
            <span className="text-[#010101] text-[14px] mr-2">
              {dataDetail?.created_at?.split("T")[0]}
            </span>
            <span className="text-[#010101] text-[14px]">
              {moment(dataDetail?.created_at).format("HH:mm:ss")}
            </span>
          </div>

          <dl class="px-[30px] mt-4 text-xs font-medium flex items-center row-start-2 sm:mt-1 sm:row-start-3 md:mt-2.5 lg:row-start-2">
            <dt class="sr-only">Reviews</dt>
            <dd class="text-indigo-600 flex items-center dark:text-indigo-400">
              <svg
                width="24"
                height="24"
                fill="none"
                aria-hidden="true"
                class="mr-1 stroke-current dark:stroke-indigo-500"
              >
                <path
                  d="m12 5 2 5h5l-4 4 2.103 5L12 16l-5.103 3L9 14l-4-4h5l2-5Z"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              <span>
                {moment(dataDetail?.date).format("DD.MM.YYYY")}{" "}
                <span class="text-slate-400 font-normal"></span>
              </span>
            </dd>
            <dt class="sr-only">Location</dt>
            <dd class="flex items-center">
              <svg
                width="2"
                height="2"
                aria-hidden="true"
                fill="currentColor"
                class="mx-3 text-slate-300"
              >
                <circle cx="1" cy="1" r="1"></circle>
              </svg>
              <svg
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="mr-1 text-slate-400 dark:text-slate-500"
                aria-hidden="true"
              >
                <path d="M18 11.034C18 14.897 12 19 12 19s-6-4.103-6-7.966C6 7.655 8.819 5 12 5s6 2.655 6 6.034Z"></path>
                <path d="M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"></path>
              </svg>
              {dataDetail?.name}
            </dd>
          </dl>

          <div className="p-4 flex flex-row items-center justify-between ">
            {" "}
            <Dropdown
              menu={{
                items,
              }}
              placement="topRight"
              arrow
            >
              <Button>
                <VscListFlat />
              </Button>
            </Dropdown>
            {!dataDetail?.confirm ? (
              <Popconfirm
                title="Etiborli boling!"
                description={" O'chirishga ishonchingiz komilmi?"}
                onConfirm={deleteVagon}
                okText="Yes"
                cancelText="No"
              >
                <Button>
                  <CgTrashEmpty />
                </Button>
              </Popconfirm>
            ) : null}
            <Modal
              style={{
                top: "0",
              }}
              footer={[]}
              title={dataDetail?.vagon + "-dan chiqim qilish"}
              open={isModalOpen}
              loading={loadVagon}
              onOk={() => {
                setIsModalOpen(false);
              }}
              onCancel={() => {
                setIsModalOpen(false);
              }}
            >
              <Formik
                innerRef={formikRef}
                initialValues={{
                  qop: "",
                  auto_number: "",
                  driver_name: "",
                  given_by: "",
                  comment: "",
                }}
                validationSchema={Yup.object({
                  qop: Yup.string().required("Yozish shart"),
                  auto_number: Yup.string().required("Yozish shart"),
                  driver_name: Yup.string().required("Yozish shart"),
                  given_by: Yup.string().required("Yozish shart"),
                  comment: Yup.string().required("yozish shart"),
                })}
                onSubmit={(values, { resetForm }) => {
                  console.log(values);
                  setChiqim(values, resetForm);
                }}
              >
                {({ resetForm }) => (
                  <Form>
                    {/* qop soni */}
                    <label htmlFor="qop" className="text-[16px]">
                      Qop soni
                    </label>
                    <Field
                      className="block w-full px-1 py-1 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="qop"
                      type="text"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage name="qop" />
                    </div>

                    {/* auto_number soni */}
                    <label htmlFor="auto_number" className="text-[16px]">
                      Auto raqam
                    </label>
                    <Field
                      className="block w-full px-1 py-1 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="auto_number"
                      type="text"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage
                        name="auto_number"
                        className="text-[16px]"
                      />
                    </div>

                    {/* driver_name soni */}
                    <label htmlFor="driver_name" className="text-[16px]">
                      Kimga
                    </label>
                    <Field
                      className="block w-full px-1 py-1 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="driver_name"
                      type="text"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage name="driver_name" />
                    </div>

                    {/* given_by soni */}
                    <label htmlFor="given_by" className="text-[16px]">
                      Kim berib yuboryapti
                    </label>
                    <Field
                      className="block w-full px-1 py-1 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="given_by"
                      type="text"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage name="given_by" />
                    </div>

                    {/* comment */}
                    <label htmlFor="comment" className="text-[16px]">
                      Izox
                    </label>
                    <Field
                      className="block w-full px-1 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="comment"
                      as="textarea"
                      rows="4"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage name="comment" />
                    </div>

                    <br />
                    <div className="flex flex-row items-center justify-between gap-1 ">
                      <button
                        disabled={loading}
                        type="submit"
                        className=" bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block "
                      >
                        {loading ? "Yuklanmoqda" : "Qo'shish"}
                      </button>
                      {/* Reset button to clear the form */}
                      <button
                        type="button"
                        className="h-[100%] bg-gray-500 text-white py-3 px-4 rounded"
                        onClick={() => formikRef.current?.resetForm()}
                      >
                        <MdOutlineRemoveCircleOutline />
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Modal>
            {oneChiqim && oneChiqimEdit ? (
              <Modal
                style={{
                  top: "0",
                }}
                footer={[]}
                title={dataDetail?.vagon + "-dan chiqim qilish"}
                open={oneChiqimEdit}
                // loading={loadVagon}
                onOk={() => {
                  setOneChiqimEdit(false);
                }}
                onCancel={() => {
                  setOneChiqimEdit(false);
                  setOneChiqim(null);
                }}
              >
                <Formik
                  initialValues={{
                    qop: oneChiqim?.qop,
                    auto_number: oneChiqim?.auto_number,
                    driver_name: oneChiqim?.driver_name,
                    given_by: oneChiqim?.given_by,
                    comment: oneChiqim?.comment,
                  }}
                  validationSchema={Yup.object({
                    qop: Yup.string().required("Yozish shart"),
                    auto_number: Yup.string().required("Yozish shart"),
                    driver_name: Yup.string().required("Yozish shart"),
                    given_by: Yup.string().required("Yozish shart"),
                    comment: Yup.string().required("yozish shart"),
                  })}
                  onSubmit={(values) => {
                    console.log(values);
                    putChiqim(values);
                  }}
                >
                  <Form>
                    {/* qop soni */}
                    <label htmlFor="qop" className="text-[16px]">
                      Qop soni
                    </label>
                    <Field
                      className="block w-full px-1 py-1 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="qop"
                      type="text"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage name="qop" />
                    </div>

                    {/* auto_number soni */}
                    <label htmlFor="auto_number" className="text-[16px]">
                      Auto raqam
                    </label>
                    <Field
                      className="block w-full px-1 py-1 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="auto_number"
                      type="text"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage
                        name="auto_number"
                        className="text-[16px]"
                      />
                    </div>

                    {/* driver_name soni */}
                    <label htmlFor="driver_name" className="text-[16px]">
                      Kimga
                    </label>
                    <Field
                      className="block w-full px-1 py-1 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="driver_name"
                      type="text"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage name="driver_name" />
                    </div>

                    {/* given_by soni */}
                    <label htmlFor="given_by" className="text-[16px]">
                      Kim berib yuboryapti
                    </label>
                    <Field
                      className="block w-full px-1 py-1 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="given_by"
                      type="text"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage name="given_by" />
                    </div>

                    {/* comment */}
                    <label htmlFor="comment" className="text-[16px]">
                      Izox
                    </label>
                    <Field
                      className="block w-full px-1 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      name="comment"
                      as="textarea"
                      rows="4"
                    />
                    <div className="mt-1 text-sm text-red-600">
                      <ErrorMessage name="comment" />
                    </div>

                    <br />
                    <div className="flex flex-row items-center justify-between gap-1 ">
                      <button
                        disabled={loading}
                        type="submit"
                        className=" bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block "
                      >
                        {loading ? "Yuklanmoqda" : "Qo'shish"}
                      </button>
                      <button
                        type="button"
                        className="h-[100%] bg-gray-500 text-white py-3 px-4 rounded"
                        onClick={() => {
                          setOneChiqim(null);
                          formikRef.current?.resetForm();
                        }}
                      >
                        <MdOutlineRemoveCircleOutline />
                      </button>
                    </div>
                  </Form>
                </Formik>
              </Modal>
            ) : null}
            <Modal
              style={{
                top: "0",
              }}
              footer={[]}
              title={dataDetail?.vagon + "-dan chiqim qilish"}
              open={isFinished}
              loading={loadVagon}
              onOk={() => {
                setIsFinished(false);
              }}
              onCancel={() => {
                setIsFinished(false);
              }}
            >
              <Formik
                innerRef={formikRef}
                initialValues={{
                  comment: "",
                }}
                validationSchema={Yup.object({
                  comment: Yup.string().required("yozish shart"),
                })}
                onSubmit={(values, { resetForm }) => {
                  console.log(values);
                  finishVagon(values);
                }}
              >
                <Form>
                  {/* comment */}
                  <label htmlFor="comment" className="text-[16px]">
                    Izox
                  </label>
                  <Field
                    className="block w-full px-1 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    name="comment"
                    as="textarea"
                    rows="4"
                  />
                  <div className="mt-1 text-sm text-red-600">
                    <ErrorMessage name="comment" />
                  </div>

                  <br />
                  <button
                    disabled={loading}
                    type="submit"
                    className="w-[100%] bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block "
                  >
                    {loading ? "Yuklanmoqda" : "Qo'shish"}
                  </button>
                </Form>
              </Formik>
            </Modal>
          </div>

          {/* w-[100%] overflow-auto */}
          <div className="w-full overflow-auto">
            <table
              style={{
                borderCollapse: "collapse",
                width: "900px", // Fixed width for the table
              }}
              border="1"
              className="text-[14px] shrink-0"
              cellPadding="1"
            >
              <thead>
                <tr>
                  <th className="text-[14px] text-left font-bold border border-gray-400 px-4 py-2 whitespace-nowrap">
                    Tn
                  </th>
                  <th className="text-[14px] text-left font-bold border border-gray-400 px-4 py-2 whitespace-nowrap">
                    qop
                  </th>
                  <th className="text-[14px] text-left font-bold border border-gray-400 px-4 py-2 whitespace-nowrap">
                    Юк номи
                  </th>
                  <th className="text-[14px] text-left font-bold border border-gray-400 px-4 py-2 whitespace-nowrap">
                    Auto raqam
                  </th>
                  <th className="text-[14px] text-left font-bold border border-gray-400 px-4 py-2 whitespace-nowrap">
                    Kimga
                  </th>
                  <th className="text-[14px] text-left font-bold border border-gray-400 px-4 py-2 whitespace-nowrap">
                    Beruvchi
                  </th>
                  <th className="text-[14px] text-left font-bold border border-gray-400 px-4 py-2 whitespace-nowrap">
                    Izox
                  </th>
                  <th className="text-[14px] text-left font-bold border border-gray-400 px-4 py-2 whitespace-nowrap">
                    O'chirish
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.chiqim?.map((el, i) => (
                  <tr key={i}>
                    <td className="text-[14px] text-left border border-gray-400 px-4 py-2 whitespace-nowrap">
                      {i + 1}.({(el.qop * 50) / 1000} tn)
                    </td>
                    <td className="text-[14px] text-left border border-gray-400 px-4 py-2 whitespace-nowrap">
                      {el.qop} qop
                    </td>
                    <td className="text-[14px] text-left border border-gray-400 px-4 py-2 whitespace-nowrap">
                      {dataDetail?.name}
                    </td>
                    <td className="text-[14px] text-left border border-gray-400 px-4 py-2 whitespace-nowrap">
                      {el.auto_number}
                    </td>
                    <td className="text-[14px] text-left border border-gray-400 px-4 py-2 whitespace-nowrap">
                      {el.driver_name}
                    </td>
                    <td className="text-[14px] text-left border border-gray-400 px-4 py-2 whitespace-nowrap">
                      {el.given_by}
                    </td>
                    <td className="text-[14px] text-left border border-gray-400 px-4 py-2 whitespace-nowrap">
                      {el.comment}
                    </td>
                    <td className="text-[14px] text-left border border-gray-400 px-4 py-2 whitespace-nowrap">
                      <div className="flex flex-row gap-1">
                        <Popconfirm
                          title="O'chirish"
                          description={" O'chirishga ishonchingiz komilmi?"}
                          onConfirm={() => delChiqim(el.id)}
                          okText="Yes"
                          cancelText="No"
                          disabled={dataDetail?.confirm}
                        >
                          <Button
                            disabled={dataDetail?.confirm}
                            color="red"
                            icon={<MdOutlineDeleteOutline />}
                          >
                            {/* Delete */}
                          </Button>
                        </Popconfirm>
                        <Button
                          // disabled={dataDetail?.confirm}
                          onClick={() => {
                            setOneChiqim({ ...el });
                            setOneChiqimEdit(true);
                          }}
                          color="red"
                          icon={<CiEdit />}
                        >
                          {/* Delete */}
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <footer>
            <div className="flex items-center justify-between w-[100%] py-[5px] pb-[60px]">
              <div>
                <p className="text-[16px] m-0 p-[3px]">
                  {data.chiqim?.reduce((cal, curr) => {
                    return cal + curr?.qop;
                  }, 0)}{" "}
                  дона Qop
                </p>
                <p className="text-[16px] m-0 p-[3px]">
                  {(data.chiqim?.reduce((cal, curr) => {
                    return cal + curr?.qop;
                  }, 0) *
                    50) /
                    1000}{" "}
                  Tn
                </p>
              </div>
              <Button
                onClick={() => {
                  setIsModalOpen(true);
                }}
                disabled={dataDetail?.confirm}
                icon={<GoPlusCircle className="font-[30px]" />}
              ></Button>
            </div>
            <Collapse
              items={collapsedItems}
              defaultActiveKey={["1"]}
              // onChange={onChange}
            />
          </footer>
        </div>
      </div>
    </div>
  );
}
